import {
  CloseIcon,
  Divider,
  GKButton,
  GKTextField,
  Grid2,
  IconButton,
  PlusIcon,
} from "components";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";

const NomineeDetails = () => {
  const form = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "clientCreation.nominees",
  });

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        {fields.map((bank: any, index: number) => (
          <Grid2
            container
            size={12}
            spacing={2}
            my={2}
            key={index}
            sx={{
              p: {
                xs: 2,
                md: 0,
              },
              border: {
                xs: "1px solid #E3E8EF",
                md: "none",
              },
              borderRadius: {
                xs: 2,
                md: 0,
              },
            }}
          >
            <Grid2 size={{ md: 3.8, xs: 12 }}>
              <Controller
                name={`clientCreation.nominees.${index}.name`}
                control={form.control}
                render={({ field }) => (
                  <GKTextField {...field} inputLabel="Nominee Name" />
                )}
              />
            </Grid2>
            <Grid2 size={{ md: 3.8, xs: 12 }}>
              <Controller
                name={`clientCreation.nominees.${index}.percentage`}
                control={form.control}
                render={({ field }) => (
                  <GKTextField {...field} inputLabel="Nominee Percentage" />
                )}
              />
            </Grid2>
            <Grid2 size={{ md: 3.8, xs: 12 }}>
              <Controller
                name={`clientCreation.nominees.${index}.relationship`}
                control={form.control}
                render={({ field }) => (
                  <GKTextField {...field} inputLabel="Relationship" />
                )}
              />
            </Grid2>
            <Grid2
              size={{ md: 0.5, xs: 12 }}
              textAlign="center"
              mt={{ md: 3, xs: 0 }}
            >
              <IconButton
                color="error"
                disabled={fields?.length === 1}
                onClick={() => remove(index)}
              >
                <CloseIcon />
              </IconButton>
            </Grid2>
          </Grid2>
        ))}
      </Grid2>
      <Grid2 size={12}>
        <Divider>
          <GKButton
            variant="outlined"
            color="dark"
            size="small"
            startIcon={<PlusIcon width={10} />}
            onClick={() =>
              append({
                name: "",
                percentage: "",
                relationship: "",
              })
            }
          >
            Add Nominee
          </GKButton>
        </Divider>
      </Grid2>
    </Grid2>
  );
};

export default NomineeDetails;
